import React from 'react';
import {
  Breadcrumb,
  Col,
  Divider,
  Layout, Row,
  Spin,
  message
} from 'antd';
import { connect } from 'react-redux';
import { Link, navigate } from '@reach/router';
import { I18n } from 'react-redux-i18n';
import { DashboardOutlined } from '@ant-design/icons';
import { ApiActions } from '../../../../app/redux/actions';
import { UserSelectors, LoadingSelectors, CommandSelectors } from '../../../../app/redux/reducers';
import { ViewType } from '../../../../app/enum/viewType';
import { ENDPOINTS } from '../../../../app/endpoints/endpoints';
import { ACTION_SAVE_COMMAND_DETAILS, ACTION_SAVE_COMMAND_HISTORY } from '../../../../app/redux/actions/command';
import { GetIcon } from '../../../../app/enum/iconList';
import { formatDateIsoString, humanizeDateTime } from '../../../../app/utils/date';
import { typeCommandText } from '../../../../app/utils/typeCommand';
class CommandAuditDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      viewType: ViewType.EDIT,
      dataDetails: null,
    };
  }

  async componentDidMount() {
    const { getById, getHistoryById, id } = this.props;

    this.setState({
      viewType: ViewType.EDIT,
    });

    try {
      await getById(id);
      await getHistoryById(id);
      this.setState({ dataDetails: this.props.dataDetails });
    } catch (error) {
      //
    }
  }

  render() {
    const { Content } = Layout;
    const { viewType, dataDetails } = this.state;
    const {
      loading,
      id,
      history
    } = this.props;

    return (
      <>
        <Content className="panel__layout__content panel__layout__content--breadcrumb">
          <Breadcrumb>
            <Breadcrumb.Item>
              <DashboardOutlined /> <span>{I18n.t('routes.panel.pageTitle')}</span>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to={`${I18n.t('routes.panel.admin.items.command.url')}/${id}`}>
                <span>{I18n.t('routes.panel.admin.items.command.pageTitle')}</span>
              </Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <span>
                {
                  I18n.t('routes.panel.admin.items.commandAudit.pageTitle')
                }
              </span>
            </Breadcrumb.Item>
          </Breadcrumb>
        </Content>

        <Content className="panel__layout__content">
          <div className="command-details">
            <Spin
              spinning={loading > 0}
              tip={I18n.t('shared.loading')}
            >
              <div className="panel__layout__content__title">
                <h2 className="panel__layout__content__title__value">
                  <span className="panel__layout__content__title__value__icon">
                    {GetIcon(
                      I18n.t('routes.panel.admin.items.command.icon'),
                      { fill: '#F37223', width: 24, height: 24 },
                    )}
                  </span>
                  {
                    I18n.t('routes.panel.admin.items.commandAudit.pageTitleEdit')
                  }
                </h2>
                <h2>
                    {I18n.t('routes.panel.admin.items.commandAudit.pageSubtitle')}
                </h2>
              </div>
              <Divider />
              <div>
                <Row>
                  <div className='commandAudit__container'>
                    {history && history.map((item) => {
                      return (
                        <span>
                            {`[${formatDateIsoString(item.commandToProcess.createdAt)}] - [${typeCommandText(item.commandToProcess.type)}] - [${item.status}] ${item.status === 'ERRO' ? `${item.desc}` : ''}`}
                        </span>
                      );
                    })}
                  </div>
                </Row>
              </div>
            </Spin>
          </div>
        </Content>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  loading: LoadingSelectors.getLoading(state),
  history: CommandSelectors.getDataHistory(state),
});
const mapDispatchToProps = (dispatch) => ({
  getById: (id) => dispatch(ApiActions.getById(id, ENDPOINTS.commands, ACTION_SAVE_COMMAND_DETAILS)),
  getHistoryById: (id) => dispatch(ApiActions.getById(id, ENDPOINTS.historyCommand, ACTION_SAVE_COMMAND_HISTORY)),
  alterCommand: (id, callback) => dispatch(ApiActions.alterCommand(id, ENDPOINTS.commands, callback)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CommandAuditDetails);
